import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';

const isTokenValid = (token) => {
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp && decoded.exp > currentTime;
  } catch (e) {
    return false;
  }
};

const PrivateRoute = () => {
  const token = localStorage.getItem('token');
  const hasPort = window.location.port !== "";
  if(hasPort){
    return <Outlet />;  
  }

  if (!token || !isTokenValid(token)) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
